import React, { Component } from 'react'
import { observer } from 'mobx-react'

import FormController from '../../form/FormController'
import Panel from '../../../UniformComponents/Panel'

@observer
export default class ProductDetails extends Component {
    constructor(props) {
        super(props)
        this.state = { loadingProdDetails: true }
        this.fields = {}
        this.init()
    }

    init = async () => {
        const { wizardStore } = this.props
        await wizardStore.initProductDetails()
        wizardStore.handleValidate = this.validate
        this.setState({ loadingProdDetails: false })
    }

    validate = () => {
        const { wizardStore } = this.props
        const { formData } = wizardStore.productDetails
        return wizardStore.validate(this.fields, formData)
    }

    renderLoader = () => (
        <div className="loader" />
    )

    render() {
        const { loadingProdDetails } = this.state
        const { wizardStore } = this.props
        return (
            <Panel cssClass="stage-card overflow-visible">
                <div id="product-details">
                    {
                        wizardStore.productDetails.formLoading || loadingProdDetails
                            ? this.renderLoader()
                            : (
                                <FormController
                                    fields={this.fields}
                                    formFields={wizardStore.productDetails.formFields}
                                    setField={wizardStore.setProductDetailsField}
                                />
                            )
                    }
                </div>
            </Panel>
        )
    }
}
